<template>
    <div>
        <div v-bind:class="ifLoading" class="loader">
            <TheSpinner />
        </div>
        <div class="teilnehmerheader" v-if="loading">
            <div class="grid md:grid-columns-12">
                <div class="column-2">
                    <div v-if="items[0].root.foto">
                        <img :src="items[0].root.foto" />
                    </div>
                    <div v-if="items[0].root.video">
                        <the-you-tube :video="items[0].root.video"/>
                    </div>
                </div>
                <div class="column-1 p-6">
                    <div class="text-2xl md:text-6xl font-extrabold">
                        <the-language :de="items[0].root.teilnehmer_de" :en="items[0].root.teilnehmer_en" /><br />
                    </div>
                    <div class="text-xl md:text-3xl font-extrabold">
                        <the-language :de="items[0].root.land_de" :en="items[0].root.land_en" />
                        <div class="tflag inline-block pl-3">
                            <img :src="items[0].root.flag" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-4 md:max-w-4xl md:m-auto">

            <the-title parentcolor="orange">
                <slot slot="de">Wettbewerbe</slot>
                <slot slot="en">competitions</slot>
            </the-title>

            <ul class="mb-5">
                <li :key="sportartItem.ID" v-for="sportartItem in items[1]" class="uppercase text-primary-red pb-2" >
                    <router-link  v-bind:to="sportartItem.router">
                        <the-language :de="sportartItem.altersklasse_de" :en="sportartItem.altersklasse_en" />
                        <the-language :de="sportartItem.sportart_de" :en="sportartItem.sportart_en" />
                    </router-link>
                </li>
            </ul>

            <the-title parentcolor="orange">
                <slot slot="de">Spielplan</slot>
                <slot slot="en">Shedule</slot>
            </the-title>

            <ul class="mb-5">
                <li
                        :key="sportartItem.ID"
                        v-for="sportartItem in items[2]"
                        v-if="sportartItem.route"
                        class="inline-block uppercase font-extrabold border-0
                            border-b-2 border-secondary-grey w-full
                            md:text-5xl md:pl-12 py-2 mb-4 pb-4"
                >
                    <div v-if="sportartItem.route">
                        <router-link  v-bind:to="sportartItem.route">
                            <div v-if="sportartItem.sheduletype == 'vorschau'">
                                <div class="px-5 text-center relative flexbox">
                                    <div class="w-full opacity-50 text-left pb-3 md:pb-0 ">
                                        <div class="text-xs bg-primary-orange text-white inline-block p-1 truncate mr-2">
                                            <the-language :de="sportartItem.sport_de" :en="sportartItem.sport_en" />
                                        </div>
                                        <div class="text-xs bg-primary-orange text-white inline-block p-1 truncate mr-2">
                                            <the-language :de="sportartItem.alter_de" :en="sportartItem.alter_en" />
                                        </div>
                                        <div class="text-xs bg-primary-orange text-white inline-block p-1 truncate mr-2">
                                            <the-language :de="sportartItem.gruppe_name_de" :en="sportartItem.gruppe_name_en" />
                                        </div>
                                    </div>
                                    <div class="gradientText inline-block w-1/2 p-5 vs border-t border-b border-primary-orange md:pl-4">
                                        <div class="flag inline-block md:float-left">
                                            <img v-bind:src="sportartItem.fahne_home">
                                        </div>
                                        <div class="truncate md:text-lg md:pl-4 md:leading-normal">
                                            <the-language :de="sportartItem.home_de" :en="sportartItem.home_en" />
                                        </div>
                                    </div>
                                    <div class="gradientText inline-block w-1/2 p-5 border-t border-b border-primary-orange md:pl-12">
                                        <div class="flag inline-block md:float-right">
                                            <img v-bind:src="sportartItem.fahne_away">
                                        </div>
                                        <div class="truncate md:text-lg md:float-left md:pl-4 md:leading-normal">
                                            <the-language :de="sportartItem.away_de" :en="sportartItem.away_en" />
                                        </div>
                                    </div>
                                </div>
                                <div class="px-5 pt-3 text-xs text-secondary-text">
                                    <p>
                                        <the-language :de="sportartItem.date_de" :en="sportartItem.date_en" /> |
                                        <the-language :de="sportartItem.sportplatz_de" :en="sportartItem.sportplatz_en" />
                                    </p>
                                </div>
                            </div>
                            <div v-if="sportartItem.sheduletype == 'ergebnis'">
                                <div class="px-5 text-center relative flexbox ergebnis">
                                    <div class="w-full opacity-50 text-left pb-3 md:pb-0 ">
                                        <div class="text-xs bg-primary-orange text-white inline-block p-1 truncate mr-2">
                                            <the-language :de="sportartItem.sport_de" :en="sportartItem.sport_en" />
                                        </div>
                                        <div class="text-xs bg-primary-orange text-white inline-block p-1 truncate mr-2">
                                            <the-language :de="sportartItem.alter_de" :en="sportartItem.alter_en" />
                                        </div>
                                        <div class="text-xs bg-primary-orange text-white inline-block p-1 truncate mr-2">
                                            <the-language :de="sportartItem.gruppe_name_de" :en="sportartItem.gruppe_name_en" />
                                        </div>
                                    </div>
                                    <div class="gradientText inline-block w-1/2 p-5 vs border-t border-b border-primary-orange md:pl-4">
                                        <div class="flag inline-block md:float-left">
                                            <img v-bind:src="sportartItem.fahne_home">
                                        </div>
                                        <div class="truncate md:text-lg md:pl-4 md:leading-normal">
                                            <div class="text-5xl">{{sportartItem.home_tore}}</div>
                                            <the-language :de="sportartItem.home_de" :en="sportartItem.home_en" />
                                        </div>
                                    </div>
                                    <div class="gradientText inline-block w-1/2 p-5 border-t border-b border-primary-orange md:pl-12">
                                        <div class="flag inline-block md:float-right">
                                            <img v-bind:src="sportartItem.fahne_away">
                                        </div>
                                        <div class="truncate md:text-lg md:float-left md:pl-4 md:leading-normal">
                                            <div class="text-5xl">{{sportartItem.away_tore}}</div>
                                            <the-language :de="sportartItem.away_de" :en="sportartItem.away_en" />
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </router-link>
                    </div>
                </li>
            </ul>
        </div>


    </div>
</template>



<script>
    import TheTitle from "../TheTitle";
    import TheLanguage from "../TheLanguage";
    import TheSpinner from "../TheSpinner"
    import TheTextView from "../TheTextView";
    import ergebnis from "../match/ergebnis";
    import teams from "../match/teams"
    import TheYouTube from "../TheYouTubeStandAlone";

    export default {
        name: 'teilnehmer',
        components: {
            TheSpinner,
            TheLanguage,
            TheTitle,
            TheTextView,
            ergebnis,
            teams,
            TheYouTube
        },
        data(){
            return{
                currentFilter: 'ALL',
                loading: false,
                items: []
            }
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/teilnehmer/'+this.$route.params.id+'.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.items = result.data,
                        this.loading = true
                })
        },
        computed: {
            ifLoading() {
                if(this.loading){
                    return 'loaded';
                }else{
                    return 'isLoading';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .teilnehmerheader{
        position: relative;
        z-index: -1;
        background-color: rgba(248,178,52,0.8);
        color: #FFF;
        background-position: right;
        background-image: url(https://api.pgsi2020.de/img/bg_ornament.svg);
        background-repeat: no-repeat;
        margin-bottom: 30px;
        padding: 10px 30px;
        @screen md{
            padding: 20px 50px;
        }
    }

    .column-1{
        grid-row: 2;
        grid-column: 1 / 12;
        -ms-grid-column: 1 / 12;
        @screen md{
            grid-row: 1;
            grid-column: 1 / 8;
            -ms-grid-column: 1 / 8;
        }

    }
    .column-2{
        grid-row: 1;
        grid-column: 1 / 12;
        -ms-grid-column: 1 / 12;
        @screen md{
            grid-row: 1;
            grid-column: 8 / 12;
            -ms-grid-column: 8 / 12;
        }
    }
    .tflag{
        padding-bottom: 0;
        width: 14%;
        @screen md{
            width: 50px;
        }
    }
</style>
